<script>
    import { fly } from 'svelte/transition';
    import { pluginUpdateAvailable } from '../../stores.js';

    function dismiss() {
        pluginUpdateAvailable.set(false);
    }
</script>

{#if $pluginUpdateAvailable}
    <div id="alertWrapper" transition:fly="{{ y: 50, duration: 500 }}">
        <div id='alertMessage'>
            <span>
                New Plugin Version Available. 
                <a href="https://postlink-downloads.s3.us-east-2.amazonaws.com/Plugin/latest/Postlink.zip" target="_blank">Download here</a>
            </span>
            <button class="close-btn" on:click={dismiss} aria-label="Dismiss alert">&times;</button>
        </div>
    </div>
{/if}

<style>
    #alertWrapper {
        position: fixed;
        bottom: 20px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 10000;
        margin: 1em;
    }

    #alertMessage {
        font-family: "Helvetica", sans-serif;
        font-weight: 225;
        font-size: 17px;
        color: antiquewhite;
        background: #e1631a8f; 
        padding: 0.8em 1.2em;
        border-radius: 10px;
        box-shadow: 0px 4px 12px rgba(0,0,0,0.3);
        margin: 0;
        display: flex;
        align-items: center;
        gap: 15px;
    }

    a {
        color: antiquewhite;
        text-decoration: underline;
        font-weight: bold;
    }

    .close-btn {
        background: transparent;
        border: none;
        color: antiquewhite;
        font-size: 24px;
        line-height: 20px;
        cursor: pointer;
        padding: 0;
        margin: 0;
        opacity: 0.7;
        transition: opacity 0.2s;
    }

    .close-btn:hover {
        opacity: 1;
    }
</style>
